import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	InfoGroupComponent,
	ItemComponent,
	ListDetailComponent,
	TagComponent,
	TooltipComponent,
	IconComponent,
} from '@tecalisdev/infinity';
import { IPolGeneralData, IPolLifeTest } from '../../../../../processes/models/processes.models';
import { ProcessHelperService } from '../../../../../processes/services/process-helper.service';
import { MasterService } from '../../../../services/master.service';
import { PolFailReasonService } from '../../../../../operations/services/pol-fail-reason.service';

@Component({
	selector: 'app-operation-pol-details-tried-data',
	imports: [
		TranslatePipe,
		DatePipe,
		DecimalPipe,
		InfoGroupComponent,
		TagComponent,
		ItemComponent,
		ListDetailComponent,
		TooltipComponent,
		IconComponent,
	],
	templateUrl: './operation-pol-details-tried-data.component.html',
	styleUrl: './operation-pol-details-tried-data.component.scss',
})
export class OperationPolDetailsTriedDataComponent {
	@Input() tried: { lifeTest: IPolLifeTest[]; general: IPolGeneralData };
	@Input() index: number = 0;

	public masterService = inject(MasterService);
	public processHelper = inject(ProcessHelperService);
	public polFailReasonService = inject(PolFailReasonService);
}
